/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Faq_A2Inputs */

const en_simple_oto_faq_a2 = /** @type {(inputs: Simple_Oto_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first stage — the first version you can use — usually lands in hours, not weeks. You may close the page; we send word when it's ready.`)
};

const id_simple_oto_faq_a2 = /** @type {(inputs: Simple_Oto_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahap pertama — versi pertama yang bisa dipakai — biasanya selesai dalam hitungan jam, bukan minggu. Kamu boleh menutup halaman; kabarnya dikirim.`)
};

/**
* | output |
* | --- |
* | "The first stage — the first version you can use — usually lands in hours, not weeks. You may close the page; we send word when it's ready." |
*
* @param {Simple_Oto_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_faq_a2 = /** @type {((inputs?: Simple_Oto_Faq_A2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Faq_A2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_faq_a2(inputs)
	return en_simple_oto_faq_a2(inputs)
});